import styles from './Logo.module.scss'

const Logo = () => (
  <div className={styles.logo}>
    <img
      alt='Logo Plurall'
      src={`${process.env.REACT_APP_ASSETS_URL}/images/plurall-login/plurall-logo-v2.svg`}
    />
  </div>
)

export default Logo
